import React, { type ComponentProps } from 'react';
import { Tabs } from 'expo-router';

import { useResponsive } from '@sg/garnish';

import { NavbarSM, NavbarXS } from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarV2 = (props: Props) => {
  const { tabBarProps } = props;

  const { minWidth } = useResponsive();

  // ─── Derived ────────────────────────────────────────────────────────

  const shouldRenderSM = minWidth.isSM;

  // ─────────────────────────────────────────────────────────────────────

  return shouldRenderSM ? <NavbarSM /> : <NavbarXS tabBarProps={tabBarProps} />;
};

// ─── Types ──────────────────────────────────────────────────────────────────

type Props = {
  tabBarProps: TabBarProps;
};

type TabBarProps = Parameters<NonNullable<ComponentProps<typeof Tabs>['tabBar']>>[0];
